import React from 'react';
import { connect } from 'react-redux';
import DKRouter from '../routers/dk-router';
import { TopSection } from 'ui/FixedFullScreen';
import ContentWrapper from './sections/ContentWrapper';
import AppToolbar from './sections/AppToolbar';
import Modals from './sections/Modals';
import Footer from './sections/Footer';
import BetslipNotifier from 'features/BetslipNotifier';
import SystemHandler from 'features/SystemHandler';
import Feedback from 'features/Feedback';
import { resetMobileBetCount } from 'features/MobileBet//state/actions';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { intercomBoot } from 'utils/trackers';
import userConductor from 'common/conductors/UserConductor';
import BetBuddyTrigger from 'features/BetBuddy/Mobile/Trigger';
import { HIDE_MOBILE_TOOLBAR_FOR_PATH } from 'configs/main';
import BetBuddyEntry from 'features/BetBuddy/Mobile';
import combinationsCountSelector from 'common/selectors/combinationsCountSelector';
import { isBetBuddySelectionsMode } from 'common/selectors/betSlipSelector';
import BottomMenuWrapped from './sections/Mobile/BottomMenu';

const FixedWrap = styled.div`
    padding-right: 5px;
    width: auto;
    position: fixed;
    display: flex;
    left: 50%;
    margin: 0;
    bottom: 65px;
    justify-content: center;
`;

const PageWrapper = styled.div`
    flex: 1;
    position: relative;
`;

class Mobile extends React.Component {
    componentDidMount() {
        let prevLocation = ''; // needed because of multiple calls of history.push inside navigateToRaceDay
        const pushPageView = () =>
            window.dataLayer.push({
                event: 'page_view',
                eventUrl: window.location.pathname,
                type: 'heste',
                userId: this.props?.userId || 0,
            });

        this.props.history.listen((location) => {
            if (prevLocation !== location.pathname) {
                if (window.dataLayer) {
                    pushPageView();
                }
                prevLocation = location.pathname;
            }
        });

        const interval = setInterval(() => {
            if (!this.props.authPending) {
                if (window.dataLayer) {
                    pushPageView();
                    prevLocation = this.props?.history?.location?.pathname;
                }
                clearInterval(interval);
            }
        }, 1000);

        intercomBoot();
        userConductor.registerUserDeviceInCMS();
    }

    // componentDidUpdate = () => {
    //     const stateAndLocalStorageDiffer =
    //         this.props.mobileBet.count !== LocalMobileBet.count();
    //
    //     if (this.state.leftSidebarStatus && stateAndLocalStorageDiffer) {
    //         this.props.resetMobileBetCount();
    //     }
    // };

    render() {
        const { location } = this.props;

        const showAppToolbar = !HIDE_MOBILE_TOOLBAR_FOR_PATH.includes(
            location.pathname.toLowerCase().split('/')[1]
        );

        return (
            <>
                <ContentWrapper
                    className="mobile-layout"
                    showAppToolbar={showAppToolbar}
                >
                    {showAppToolbar && (
                        <TopSection>
                            <AppToolbar />
                        </TopSection>
                    )}

                    <PageWrapper>
                        <DKRouter />
                    </PageWrapper>

                    <Feedback />

                    <Footer />

                    <FixedWrap style={{ zIndex: 1 }}>
                        <div style={{ position: 'relative', left: '-50%' }}>
                            {!this.props.betBuddySelectionsMode && (
                                <BetslipNotifier />
                            )}
                        </div>
                        {this.props.isVProduct && (
                            <BetBuddyTrigger
                                isHorseSelected={this.props.isHorseSelected}
                            />
                        )}
                    </FixedWrap>

                    <BottomMenuWrapped />

                    <Modals />

                    <BetBuddyEntry />

                    <SystemHandler />
                </ContentWrapper>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userId: state.auth?.user?.id,
        authPending: state.auth?.pending,
        mobileBet: state.MobileBet,
        isHorseSelected: combinationsCountSelector(state) > 0,
        betBuddySelectionsMode: isBetBuddySelectionsMode(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetMobileBetCount: () => {
            dispatch(resetMobileBetCount());
        },
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Mobile)
);
